import { useAppStore } from '../store/appStore';
import './sync_warning_banner.css';

/** Offline / backend sync warning (tech-spec §16). */
export function SyncWarningBanner() {
  const syncWarning = useAppStore((s) => s.syncWarning);
  const dismissSyncWarning = useAppStore((s) => s.dismissSyncWarning);

  if (syncWarning == null || syncWarning === '') {
    return null;
  }

  return (
    <div className="sync-warning-banner" role="status">
      <span className="sync-warning-banner__text">{syncWarning}</span>
      <button
        type="button"
        className="sync-warning-banner__dismiss"
        onClick={() => dismissSyncWarning()}
        aria-label="Закрыть"
      >
        ×
      </button>
    </div>
  );
}
